<template>
  <app-page-subsection :title="$t('teacher.page.testimonials_title')">
    <teacher-testimonial-list :list="testimonials" />
  </app-page-subsection>
</template>

<script lang="ts" setup>
import type { TeacherPageView } from "~/business-areas/teacher/teacher.model";

defineProps<{
  testimonials: TeacherPageView["testimonials"];
}>();
</script>
